import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Slider from '../../../components/slider'
import Spacer from '../../../components/spacer'
import { jewelryTypeIsRing } from '../../../utils/jewelry-validation'

class RingSizePanel extends Component {
  render () {
    const props = this.props
    return (
      <JewelryPanel
        id='ringSizePanel'
        show={jewelryTypeIsRing(props)}
        isResetting={props.isResetting}>

        <Spacer xxs />

        <h4 id='ringsize'>Ring Size</h4>
        <Slider
          id='ring_size'
          sliderId={'ring_size'}
          single
          input
          min={0}
          max={16.0}
          step={0.25}
          value={props.ring_size}
          onChange={props.onChangeVal.bind(this, 'ring_size')}
        />

      </JewelryPanel>
    )
  }
}

export default RingSizePanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/ring-size-panel/index.js